<template>
    <div :class="[$style.title_wrapper, props.limitedAvailability && $style.darken_filter]">
        <Typography
            :type="props.unavailable ? 'caption' : 'label'"
            size="m"
            semibold
            :responsive="false"
            :class="props.unavailable ? $style.title_unavailable : $style.title"
        >
            {{ topText }}
        </Typography>
        <Typography
            v-if="props.unavailable"
            type="label"
            size="xs"
            :responsive="false"
            :class="$style.description"
        >
            <!-- eslint-disable vue/no-v-html -->
            <p v-html="tr('unavailableGame.description')" />
        </Typography>
        <Typography
            v-else-if="props.category"
            type="caption"
            size="m"
            :responsive="false"
            :class="$style.category"
        >
            {{ props.category }}
        </Typography>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import Typography from '@/components/Typography.vue'
import { useTr } from '@/composables/use-tr'
import type { APIGameType } from '@/types'

export type GameInfoTitleProps = {
    game?: APIGameType
    category?: string
    placement?: 'desktop_footer' | 'init_screen' | 'mobile_game_container'
    unavailable?: boolean
    limitedAvailability?: boolean
}

const props = defineProps<GameInfoTitleProps>()

const tr = useTr()

const topText = computed(() => {
    if (props.unavailable) {
        return tr('unavailableGame.oops')
    }
    return props.game
        ? `${props.game?.title}${props.placement === 'init_screen' && props.game?.gameUrlRedirectTarget ? ' *' : ''}`
        : ''
})
</script>

<style module>
.title_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    flex-shrink: 1;
    min-width: 0;
}

.title,
.category,
.description {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.title_unavailable {
    margin-top: -4px;
    margin-bottom: -2px;
}

.category,
.description {
    color: var(--white-40);
}

.darken_filter {
    filter: grayscale(100%) brightness(65%);
}
</style>
